import styled from 'styled-components';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiMenu from '@mui/material/Menu';

export const ViewMoreWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 10px 0 20px;
  background: transparent;
`;

export const ViewMoreButton = styled.button`
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: ${(props) => props.theme.primary.main};
  background: transparent;
  border: 0;
  cursor: pointer;
`;

export const Drawer = styled(MuiDrawer)`
  .MuiDrawer-paper {
    width: 80vw;
    min-width: 396px;
    background: ${(props) => props.theme.palette.background.default};
    height: 100vh;
    overflow: hidden;
  }

  .notification-main-content {
    height: calc(100% - 18vh);
  }

  .main-tab-content {
    height: calc(100% - 58px);
  }

  .list-stocks {
    width: 80vw;
    padding-left: 15px;
    padding-right: 15px;
  }

  .list-stocks::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0); /* Set thumb color to transparent */
  }

  .drawer-main-content {
    width: 100%;
    height: 100%;
  }

  .menu-text {
    margin-left: 5px;
  }

  .search {
    max-width: 180px;
    min-width: 180px;
  }

  .title-block {
    .MuiSvgIcon-root {
      color: ${(props) => props.theme.input.color};
    }

    .title {
      font-size: 16px;
    }
  }

  .filter-block {
    .MuiSvgIcon-root {
      color: ${(props) => props.theme.input.color};
    }
    .MuiButtonBase-root.btn-mask-ask-read {
      min-width: 180px;
    }
  }

  .MuiTab-root {
    &.Mui-selected {
      color: ${(props) => props.theme.primary.main};
    }
  }

  .MuiTabs-indicator {
    background-color: ${(props) => props.theme.primary.main};
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    .MuiDrawer-paper {
      min-width: 308px;
      width: 95vw;
    }
    .list-stocks {
      width: 95vw;
    }

    .search {
      width: 150px;
    }
  }
`;

export const Menu = styled(MuiMenu)`
  .menu-text {
    margin-left: 5px;
  }

  .MuiButtonBase-root {
    &.selected {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

export const NotificationItem = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 0;

  .MuiCard-root {
    margin-left: 15px;
  }

  .dot-badge {
    color: #dedede;
  }

  .notification-icon {
    width: 36px;

    svg {
      width: 36px;
      height: 36px;
    }
  }

  .notification-content {
    width: 100%;
    padding: 15px;
    margin: 0;
  }

  .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 14px;
    background: ${(props) => props.theme.notification.header};
  }

  .MuiSvgIcon-root {
    width: 20px;
  }

  .icon-wrapper {
    display: inline-flex;
    align-items: center;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    .notification-header {
      padding-left: 0px;
    }
  }
`;

export const TabPanel = styled.div`
  height: calc(100%);

  .tab-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .tab-main-content {
    max-height: calc(100vh - 150px);
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;
    overflow-y: auto;
  }

  .tab-footer {
    position: sticky;

    .MuiButton-root {
      width: 100%;
      padding: 10px 5px;
      border-radius: 0;
    }
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    .tab-main-content {
      padding-left: 0px;
    }
  }
`;

export const FakeDropdown = styled.span`
  .MuiSvgIcon-root {
    transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  &.opened {
    .MuiSvgIcon-root {
      transform: rotate(-180deg);
    }
  }
`;

export const StockWrapper = styled.div`
  .MuiButton-root {
    min-width: unset;
    margin-right: 8px;
  }
`;
